import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "nav flex-column" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "mas fs-4 me-2" }
const _hoisted_4 = ["href", "aria-controls"]
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "mas fs-4 me-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "rotate-arrow mas fs-4 fw-700" }, "expand_less", -1)
const _hoisted_8 = ["id", "data-bs-parent"]
const _hoisted_9 = { class: "collapse-content list-unstyled text-white mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", null, [
      (!this.hasSubMenu)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            class: "btn btn-toggle d-flex justify-content-between align-items-center border-bottom-0 rounded-0 fs-6 text-white py-2",
            to: this.to,
            onClick: this.toggleMenu
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("i", _hoisted_3, _toDisplayString(this.icon), 1),
                _createTextVNode(_toDisplayString(this.title), 1)
              ])
            ]),
            _: 1
          }, 8, ["to", "onClick"]))
        : _createCommentVNode("", true),
      (this.hasSubMenu)
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            class: _normalizeClass(["collapsed btn btn-toggle d-flex justify-content-between align-items-center border-bottom-0 rounded-0 fs-6 text-white py-2", { 'rotated': this.isActive }]),
            "data-bs-toggle": "collapse",
            href: '#' + this.id,
            role: "button",
            "aria-expanded": "false",
            "aria-controls": this.id,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (this.toggleIsActive && this.toggleIsActive(...args)))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("i", _hoisted_6, _toDisplayString(this.icon), 1),
              _createTextVNode(_toDisplayString(this.title), 1)
            ]),
            _hoisted_7
          ], 10, _hoisted_4))
        : _createCommentVNode("", true),
      (this.hasSubMenu)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            id: this.id,
            class: "collapse hidden",
            "data-bs-parent": '#' + this.parentCollapseId
          }, [
            _createElementVNode("ul", _hoisted_9, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ], 8, _hoisted_8))
        : _createCommentVNode("", true)
    ])
  ]))
}